import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import { Button } from '@marriott/mi-ui-library';

import { CarouselWrapperComponent } from '../CarouselControls';
import { StyledTierTabSlider } from './MembershipTierTabSlider.styles';
import type { MembershipTierTabSliderProps } from './MembershipTierTabSlider.types';

export const MembershipTierTabSlider: FC<MembershipTierTabSliderProps> = ({
  tiers,
  selectedIndex,
  onSelect,
  desktopColumns,
  tabletColumns,
  mobileColumns,
  tabLabel,
}) => {
  const slides = useMemo(
    () =>
      tiers.map((tier, index) => (
        <div
          className="glide__slide tier-tab-slide d-flex justify-content-center align-items-stretch"
          key={`${tier.tierName}-${index}`}
        >
          <Button
            className={clsx('tier-tab-button t-font-xs', {
              'tier-tab-button--active': selectedIndex === index,
            })}
            testId={tier.name}
            buttonCopy={tier.name}
            callback={() => onSelect(index)}
            custom_click_track_value={`${tier.name}-${tabLabel}`}
          />
        </div>
      )),
    [onSelect, selectedIndex, tiers]
  );

  return (
    <StyledTierTabSlider>
      <div className="tier-tab-slider__inner">
        <CarouselWrapperComponent
          carousel={true}
          totalSlideLen={tiers.length}
          desktopColumns={desktopColumns}
          tabletColumns={tabletColumns}
          mobileColumns={mobileColumns}
          wrapperId="membership-tier-tabs"
          isMemberBenefitsSlider={true}
        >
          {slides}
        </CarouselWrapperComponent>
      </div>
    </StyledTierTabSlider>
  );
};
